import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  @Input() isVisible: boolean = false;
  @Input() message: string = 'Warning !'; 
  @Input() bgColor: string = 'bg-[#FFFBFA]'; 
  @Input() borderColor: string = 'border-[#FDA29B]';
  @Input() iconSrc: string = 'assets/icons/alert.svg';
}
